import { DSIcon } from "@Components/common/byb-ds/icons";
import { AccountCard, AccountPageLayout } from "@Components/game/account";
import CenteredLoadingOverlay from "@Components/generic/centered-loading-overlay";
import Icon from "@Components/generic/icon";
import { AccountSelectionProvider, useAccountSelection } from "@Context/common/account/account-selection-context";
import { Actions, Events } from "@Context/common/general/context";
import { useGlobalContext } from "@hooks/index";
import useI18n from "@i18n";
import { Box, IconButton, useTheme } from "@mui/material";
import { useEffect } from "react";

const AccountSelectionContent = () => {
  const { dispatch } = useGlobalContext();
  const { accounts, handleAccountSelect, loading } = useAccountSelection();
  const { i18n } = useI18n();
  const theme = useTheme();

  useEffect(() => {
    Events.app.exclusivePageEntered.emit();
    return () => {
      Events.app.exclusivePageExited.emit();
    };
  }, []);

  const logout = () => {
    dispatch({ type: Actions.FirebaseActions.Logout });
  };

  return (
    <>
      <Box sx={theme => ({ position: "absolute", top: theme.spacing(4), left: theme.spacing(4), zIndex: 1 })}>
        <IconButton size="large" onClick={logout}>
          <Icon dsIcon={DSIcon.LOG_OUT} size={32} color={theme.palette.dsBase.v200} />
        </IconButton>
      </Box>
      <AccountPageLayout pageId="SELECT_ACCOUNT" title={i18n("account.selection.title")} description={i18n("account.selection.description")} centered={true}>
        <CenteredLoadingOverlay loading={loading} />
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              sm: "repeat(2, minmax(0, 1fr))",
              md: "repeat(3, minmax(0, 1fr))",
            },
            gap: 2,
            width: "100%",
            maxWidth: 1200,
            margin: "0 auto",
            alignItems: "start",
          }}
        >
          {accounts.map(account => (
            <Box key={account.id}>
              <AccountCard name={account.name} memberCount={account.members?.length || 0} onClick={() => handleAccountSelect(account.id)} />
            </Box>
          ))}
        </Box>
      </AccountPageLayout>
    </>
  );
};

const AccountSelection = () => {
  return (
    <AccountSelectionProvider>
      <AccountSelectionContent />
    </AccountSelectionProvider>
  );
};

export default AccountSelection;
